import Vue from 'vue'
import VueSocketio from 'vue-socket.io'
import store from './../store'
import AppConfig from './config/AppConfig'

const GLOBAL_CONFIG = AppConfig.load()

// Extraer la base URL sin path para la conexión del socket
const socketUrl = GLOBAL_CONFIG.SOCKET_SERVER.replace(/\/api\/?$/, '')

Vue.use(
  new VueSocketio({
    debug: true,
    connection: socketUrl,
    options: {
      path: '/api/socket.io',
      transports: ['websocket', 'polling'],
    },
    vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_',
    },
  })
)
